module.exports = __webpack_public_path__ + "static/media/oasis_cube_shop4.b8fc14e7.webp";